import React from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import "./Breadcrumbs.scss"

const Breadcrumbs = ({ data }) => {
  const renderSlash = (array, index) => {
    if (index < array?.length - 1) return <span className="delimiter">&gt;</span>
  }

  return (
    <nav className="prime-breadcrumbs">
      {data?.map((item, index) => {
        // url provided
        if (item.url)
          return (
            <span key={item.label}>
              <Link
                to={item.url}
                className="breadcrumb-item-link"
              >
                {item.label}
              </Link>
              {renderSlash(data, index)}
            </span>
          )

        // no url
        return (
          <span key={item.label}>
            <span
              key={item.label}
              className="breadcrumb-item-last"
            >
              {item.label}
            </span>
            {renderSlash(data, index)}
          </span>
        )
      })}
    </nav>
  )
}

Breadcrumbs.propTypes = {
  // [ { label, url }, { label } ]
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ),
}

export default Breadcrumbs
